import logo from './logo.svg';
import React from 'react'
import { useEffect, useState } from 'react';
import './App.css';
import Repertoire from './Repertoire';
import SingleWork from './SingleWork';
import Landing from './Landing';
import Socials from './Socials';
import Booking from './Booking';
import Contact from './Contact';
// import works from './works.json'
import {Routes, Route, Link} from 'react-router-dom';



function App() {

const [workList, setWorkList] = useState([]);

useEffect(() => {
  // fetch(`http://localhost:3000/works.json`)
  fetch(`https://krzwlmusic.com/works.json`)
    .then((response) => response.json())
    .then((jsonData) => setWorkList(jsonData))
    .catch((error) => console.log(error));
}, []);

// console.log(workList)


  return (
    <div className="App">
      {/* <div className="row" id="headerBar">
      <Link to={"/"}><span>JAY "KURZWIEL" OYEBADEJO</span></Link>
      </div> */}
      <div className="row" id="appBody">
        <Routes>
          <Route path="/" element={<Landing/>} />
          <Route path="socials" element={<Socials/>} />
          <Route path="booking" element={<Booking/>} />
          <Route path="contact" element={<Contact/>} />
          {/* <Route path="works" element={<Repertoire works={workList}/>} /> */}
          {/* <Route path="works" element={<Repertoire works={workList}/>} /> */}
          <Route path="all-works" element={<Repertoire works={workList}/>} />
          <Route path="single-work" element={<SingleWork />} />
        </Routes>
      </div>
    </div>
  );
}

export default App;
